import { $getState, createState, type LexicalNode, type StateConfig } from "lexical";
import { BLOCK_ID_KEY, IDENTIFIED_NODE_TYPES, isBlockId } from "../../core/block-id";
import type { BlockId } from "../../core/types";

/**
 * The persistent block ID, stored as NodeState so it serializes with the node (`"$": {"blockId"}`)
 * and travels through history for free. `resetOnCopyNode` matters: `@lexical/list` builds new items
 * and split lists with `$copyNode`, which would otherwise hand the same ID to two nodes.
 */
export const blockIdState: StateConfig<typeof BLOCK_ID_KEY, BlockId | null> = createState(
  BLOCK_ID_KEY,
  {
    parse: (value) => (isBlockId(value) ? value : null),
    resetOnCopyNode: true,
  },
);

export const $getBlockId = (node: LexicalNode): BlockId | null => $getState(node, blockIdState);

/** Whether nodes of this type carry a persistent ID. The list lives in core, next to the format. */
export const $isIdentified = (node: LexicalNode): boolean =>
  IDENTIFIED_NODE_TYPES.has(node.getType());
